export class Role {
  roletype: RoleType;
}
export enum RoleType {
  Default_Contractor = 'DEFAULT_CONTRACTOR',
  Basic_Admin = 'BASIC_ADMIN',
  System_Admin = 'SYSTEM_ADMIN',
  Contractor_Admin = 'CONTRACTOR_ADMIN',
  Contractor_Mid_Level_Staff = 'CONTRACTOR_MID_LEVEL_STAFF',
  Contractor_Basic_Staff = 'CONTRACTOR_BASIC_STAFF',
}
